
  import { mapState } from 'vuex'
  export default {
    name: 'Theme2MissionExchangeRewardItemCard',
    props: {
      status: {
        type: String,
        default: ''
      },
      item: {
        type: Object,
        default: () => {}
      },
      disabled: {
        type: Boolean,
        default: false
      }
    },
    data() {
      return {
        displayClaimCreditModal: false,
        claimedSuccessfulModal: false,
        claimedFailModal: false,
        errorMessage: ''
      }
    },
    computed: {
      ...mapState({
        missionsSettings: state => state.activities['mission-reward'].missionsSettings,
        player: state => state.player.player,
        activityWallet: state => state.player.activityWallet,
        errorMessagesFromStore: state => state.themes['language-string'].errorStrings,
        isLogin: state => state.settings.isLogin
      })
    },
    methods: {
      onClaim() {
        this.displayClaimCreditModal = true
      },
      onClaimSuccessful() {
        this.$emit('refetch')
        this.claimedSuccessfulModal = true
        setTimeout(() => {
          this.claimedSuccessfulModal = false
        }, 1000)
      },
      onClaimFailed(message) {
        const { code, message: errorMessage } = message
        this.claimedFailModal = true
        this.errorMessage = this.errorMessagesFromStore[code] || errorMessage
      }
    }
  }
